<button type="button" class="dm-tooltip-inner--btn set-focus" [placement]="dmPlacement"
     [ngbPopover]="ngbTooltipContent" [triggers]="dmTriggers"  #p="ngbPopover" (click)="p.toggle(); logClick()"
    (blur)="p.close()"  (keydown.tab)="p.close()"  (keydown.shift.tab)="p.close()"  (keydown.ArrowDown)="p.close()"
     (keydown.Escape)="p.close(); $event.stopPropagation()"  [attr.aria-label]="ariaLabelToolTip" [attr.aria-expanded]="p.isOpen()">
    <span [class]="dmIcon" aria-hidden="true"></span>
</button>